import Link from "@amzn/awsui-components-react/polaris/link";
import React from "react";
import {
  MDF_SELF_EXTEND_LINK,
  PARTNER_FUNDING_BENEFIT_GUIDE_LINK,
} from "shared/util/constants/constantValues";

export const mdfBanner = (setNotificationsItems) => {
  const currentDate = new Date();
  const currentYear = new Date().getFullYear();

  const lastDayOfOctober = new Date(currentYear, 9, 31); // October 31st
  const lastDayOfYear = new Date(currentYear, 11, 31); // December 31st

  const targetDate = new Date(currentYear, 6, 12);

  if (currentDate >= lastDayOfOctober && currentDate <= lastDayOfYear) {
    return {
      type: "warning",
      content: (
        <React.Fragment>
          December 1, {currentYear} is the final day for partners to submit fund requests
          with a project end date ending in {currentYear}. Per APN funding policy, all
          fund requests will expire 30 days after the project end date. Partners
          are encouraged to{" "}
          <Link
            href={MDF_SELF_EXTEND_LINK}
            color="inverted"
            target="_blank"
            rel="noopener noreferrer"
          >
            self-extend their fund requests
          </Link>{" "}
          before the fund request expiration date and prior to migrating to
          Partner Central in the AWS Console. The last day for partners to
          submit fund claim actuals is December 21, {currentYear}. As a reminder,
          partners must submit fund claim actuals and receive approval prior to
          submitting their webform invoice.
        </React.Fragment>
      ),
      dismissible: true,
      dismissLabel: "Dismiss message",
      onDismiss: () => setNotificationsItems([]),
      id: "mdf_display_banner",
    };
  } else if (currentDate <= targetDate) {
    return {
      type: "warning",
      content: (
        <React.Fragment>
          Reminder: For MDF funding, up to 50% of your MDF Cash Wallet Balance
          will expire on June 30th if these funds are not associated with a fund
          request submission (regardless of activity start date). Refer to the{" "}
          <Link
            href={PARTNER_FUNDING_BENEFIT_GUIDE_LINK}
            color="inverted"
            target="_blank"
            rel="noopener noreferrer"
          >
            AWS Partner Funding Benefit Guide
          </Link>{" "}
          for more details.
        </React.Fragment>
      ),
      dismissible: true,
      dismissLabel: "Dismiss message",
      onDismiss: () => setNotificationsItems([]),
      id: "mdf_display_banner",
    };
  }

  return null;
};
